import { createTheme } from "@mui/material/styles";

import interBoldUrl from "../assets/fonts/Inter-Bold.ttf?url";
import interLightUrl from "../assets/fonts/Inter-Light.ttf?url";
import interRegularUrl from "../assets/fonts/Inter-Regular.ttf?url";
import interSemiBoldUrl from "../assets/fonts/Inter-SemiBold.ttf?url";

const theme = createTheme({
  typography: {
    fontFamily: "var(--font-family-base, Inter-Regular), sans-serif",
    allVariants: {
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      textRendering: "optimizeLegibility",
      fontSmooth: "always",
    },
    h1: { fontWeight: 700, fontSize: "6rem" },
    h2: { fontWeight: 700, fontSize: "3.75rem" },
    h3: { fontWeight: 700, fontSize: "3rem" },
    h4: {
      fontWeight: 600,
      fontSize: "2.125rem",
      letterSpacing: "0px",
      lineHeight: 0.794,
    },
    h5: { fontWeight: 700, fontSize: "1.5rem" },
    h6: {
      fontWeight: 600,
      fontSize: "1.25rem",
      lineHeight: 3,
      letterSpacing: 0,
    },
    body1: { fontSize: "var(--self-iam-card-header-font-size)", lineHeight: 1.5, letterSpacing: "0px" },
    body2: { fontSize: "0.875rem", lineHeight: 1.428, letterSpacing: "0px" },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Inter-Regular';
          font-style: normal;
          font-weight: 400;
          src: url('${interRegularUrl}') format('truetype');
          font-display: swap;
        }
        @font-face {
          font-family: 'Inter-Light';
          font-style: normal;
          font-weight: 300;
          src: url('${interLightUrl}') format('truetype');
          font-display: swap;
        }
        @font-face {
          font-family: 'Inter-Bold';
          font-style: normal;
          font-weight: 700;
          src: url('${interBoldUrl}') format('truetype');
          font-display: swap;
        }
        @font-face {
          font-family: 'Inter-SemiBold';
          font-style: normal;
          font-weight: 600;
          src: url('${interSemiBoldUrl}') format('truetype');
          font-display: swap;
        }
        body {
          font-family: var(--font-family-base, "Inter-Regular"), sans-serif;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          text-rendering: optimizeLegibility;
        }
      `,
    },
  },
  palette: {
    primary: {
      main: "#1aa7ee",
    },
    secondary: {
      main: "#1a2680",
    },
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.6)",
    },
  },
});

export default theme;
